import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Tabs, Tab } from "react-bootstrap";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import usePermission from "../../utils/usePermission";
import RsfAnalyticsDashboard from "./RsfAnalyticsDashboard";
import { useSidebarNavigation } from "../../customHooks/SidebarNavigation/useSidebarNavigation"; 
const RsfDashboard = () => {
  const canViewOrderAnalytics = usePermission("ORDERS_ANALYTICS_VIEW");
  const canViewIgmAnalytics = usePermission("IGM_ANALYTICS_VIEW");

  const [key, setKey] = useState("rsf");
  const {hasService } = useSidebarNavigation();
  return (
    <>
        <>
          <div className="container-fluid">
            <div className="row d-flex align-items-center ordertabs p-2">
              <div className="col d-flex">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                >
                  
                  {(hasService(1) || hasService(2)) && (
                    <Tab
                      eventKey="orders"
                      title={
                        <Link to="/" className="nav-link">
                          Orders
                        </Link>
                      }
                    >
                      <div></div>
                    </Tab>
                  )}

                  
                   {hasService(6) && (

                    <Tab
                      eventKey="igm"
                      title={
                        <Link to="/IgmDash" className="nav-link">
                          IGM
                        </Link>
                      }
                    >
                      <div></div>
                    </Tab>
                  )}

                  {hasService(5) && (
                    <Tab
                      eventKey="rsf"
                      title={
                        <Link to="/RsfDash" className="nav-link">
                          RSF
                        </Link>
                      }
                    >
                      <div></div>
                    </Tab>
                  )}
                
                </Tabs>
              </div>
            </div>
            
            {/* RSF Analytics Dashboard */}
            <RsfAnalyticsDashboard />
          </div>
        </>
    </>
  );
};

export default RsfDashboard;
